import { Controller, useFormContext } from 'react-hook-form'
import { IconBuilding, IconHome2 } from '@tabler/icons-react'
import clsx from 'clsx'

import IconButton from '../../IconButton'

import styles from './ControlledIconButton.module.scss'

interface ControlledIconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  name: string
  value: string
  defaultValue: string
}

function getIconByValue(value: string) {
  if (value === 'home') {
    return <IconHome2 />
  }

  if (value === 'company') {
    return <IconBuilding />
  }

  return <IconBuilding />
}

export function ControlledIconButton({
  defaultValue,
  name,
  value,
  className,
  ...props
}: ControlledIconButtonProps) {
  const { control } = useFormContext()

  return (
    <Controller
      defaultValue={defaultValue}
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <IconButton
            variant='gray'
            size='medium'
            onClick={() => field.onChange(value)}
            {...props}
            className={clsx(
              styles.iconButton,
              { [styles.selected]: field.value === value },
              className
            )}
          >
            {getIconByValue(value)}
          </IconButton>
        )
      }}
    />
  )
}
